<template>
  <div id="main">
    <mv-full-page
        :isPointer="false"
        :isV="isV"
        :pages="pageCount"
        :page.sync="currentPage"
        :isCache="true"
        height="calc(100% - 0.72rem)"
        :transition="{
        duration: '500ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s' // 动画延迟
      }"
        @rollEnd="onRollEnd"
        :config="{
        disabled: this.localValue
      }"
    >
      <template #page1>
        <div class="banner">
          <div class="banner-text luolan-text">澜渟 洛澜<br/>多功能产后治疗一体机</div>
          <div class="banner-copyright">
            广告审查批准文号：苏械广审(文)第270819-19796号 盆底康复治疗仪 医疗器械注册证编号：苏械注准20222090944<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page2>
        <div class="sanwei">
          <div class="sanwei-content">
            <div class="sanwei-text luolan-text">洛澜盆底康复治疗仪</div>
            <div class="sanwei-sub-text">三维修复</div>
            <img class="sanwei-img" :src="require('@/assets/img/product/luolan/sanwei-img.png')"/>
          </div>
          <div class="sanwei-copyright">
            广告审查批准文号：苏械广审(文)第270814-19316号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page3>
        <div class="sanwei-banner">
          <div class="sanwei-banner-text luolan-text">
            三维修复
          </div>
          <full-swiper :datas="sanweiBanner"></full-swiper>
        </div>
      </template>
      <template #page4>
        <div class="smart-pattern">
          <div class="sp-item">
            <img class="sp-img" :src="require('@/assets/img/product/luolan/smart.png')"/>
            <div class="sp-text">治疗方案 智能定制 不套用模板</div>
            <div class="sp-sub-text">
              根据盆底受损程度和用户需求，运用AI大数据智能算法技术，智能生成专属的治疗参数，千人千面定制方案。
            </div>
            <div class="sp-copyright">
              广告审查批准文号：苏械广审(文)第270311-04523号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
              请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
            </div>
          </div>
          <div class="sp-item">
            <img class="sp-img" :src="require('@/assets/img/product/luolan/pattern.png')"/>
            <div class="sp-text">九大训练模式</div>
            <div class="sp-sub-text">采用疗程化形式，每个疗程由多节方案组成，每节方案则由一个或多个训练模式组成。</div>
            <div class="sp-copyright">
              广告审查批准文号：苏械广审(文)第270731-17965号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
              请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
            </div>
          </div>
        </div>
      </template>
      <template #page5>
        <div class="technology">
          <div class="technology-text luolan-text">
            三重核心技术
          </div>
          <div class="technology-list">
            <div class="technology-item">
              <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-1.png')"/>
              <div class="technology-sub-text">神经肌肉电刺激</div>
              <div class="technology-text">自愈力</div>
            </div>
            <div class="technology-item">
              <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-2.png')"/>
              <div class="technology-sub-text">肌电生物反馈</div>
              <div class="technology-text">运动力</div>
            </div>
            <div class="technology-item">
              <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-3.png')"/>
              <div class="technology-sub-text">压力生物反馈</div>
              <div class="technology-text">耐受力</div>
            </div>
          </div>
          <div class="technology-copyright">
            广告审查批准文号：苏械广审(文)第270731-17964号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
            请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
    </mv-full-page>
  </div>
</template>

<script>
import "@/assets/css/animate.min.css";
import "mv-full-page/lib-dist/mv-full-page.css";
import MvFullPage from "mv-full-page";
import Vue from "vue";
import directives from "@/utils/directives";
import {FullSwiper} from "@/components/full-swiper";

Vue.use(directives);
Vue.use(MvFullPage);

export default {
  data() {
    return {
      localValue: this.value,
      isV: true,
      currentPage: 1,
      pageCount: 5,
      sanweiBanner: [
        {
          path: require('@/assets/img/product/luolan/sanwei-1.png'),
          title: '',
          desc: '',
          words: '广告审查批准文号：苏械广审(文)第270814-19317号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/luolan/sanwei-2.png'),
          title: '',
          desc: '',
          words: '广告审查批准文号：苏械广审(文)第270814-19319号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/luolan/sanwei-3.png'),
          title: '',
          desc: '',
          words: '广告审查批准文号：苏械广审(文)第270731-17963号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
      ],
    };
  },
  props: {
    value: {
      //数据源（必填）
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$parent.$emit("rollInit");
  },
  methods: {
    onRollEnd(page) {
      this.$parent.$emit("rollPage", page);
      if (page === this.pageCount) {
        this.$parent.$emit("rollEnd");
      } else {
        this.$parent.$emit("rollTop");
      }
    }
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    currentPage(val) {
      if (val === 1) {
        this.localValue = false;
      }
    }
  },
  components: {FullSwiper}
};
</script>

<style lang="scss" scoped>
.full-page-wrapper {
  top: 0.72rem;

  // 强制第一页全屏
  /deep/ .all-page .page:nth-child(1) {
    height: calc(100% / 5 + 0.72rem) !important;
    margin-top: -0.72rem !important;
  }
}

.banner {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/product/luolan/banner-bg.png") no-repeat;
  background-size: cover;
  background-position-y: center;

  > .banner-text {
    text-align: left;
    position: absolute;
    left: 0.9rem;
    bottom: 1.09rem;
  }

  > .banner-copyright {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0.24rem;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: rgba(255, 255, 255, 0.64);
  }
}

.sanwei {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/product/luolan/sanwei-bg.png") no-repeat;
  background-size: cover;
  background-position-y: center;

  > .sanwei-content {
    position: relative;
    left: 0.9rem;
    width: 7.16rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > .sanwei-text {
      margin-bottom: 0.12rem;
    }

    > .sanwei-sub-text {
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      margin-bottom: 0.6rem;
    }

    > .sanwei-img {
      width: 7.16rem;
    }
  }

  > .sanwei-copyright {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0.24rem;

    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: rgba(255, 255, 255, 0.64);
  }
}

.sanwei-banner {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fafbfe;
  padding: 0 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > .sanwei-banner-text {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .swiper {
    border-radius: 0.24rem;
    width: 100%;
    height: 7.62rem;
  }

  /deep/ .img-copyright {
    padding-right: 0;
    padding-left: 0.3rem;
    text-align: left;

    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: rgba(255, 255, 255, 0.64);
  }
}

.smart-pattern {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fafbfe;
  padding: 0 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 0.24rem;

  > .sp-item {
    background: #F5F5F7;
    border-radius: 0.24rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 8.58rem;
    height: 6.37rem;

    > .sp-img {
      width: 100%;
    }

    > .sp-text {
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      margin-top: 0.24rem;
      width: 100%;
      text-align: center;
    }

    > .sp-sub-text {
      font-weight: 400;
      font-size: 0.2rem;
      color: #666666;
      line-height: 0.28rem;
      width: 100%;
      text-align: center;
      padding: 0.12rem 0.34rem 0.24rem;
    }

    > .sp-copyright {
      font-weight: 400;
      font-size: 0.12rem;
      color: rgba(255, 255, 255, 0.64);
      text-align: left;
      line-height: 0.17rem;
      position: absolute;
      top: 4.31rem;
      left: 0.3rem;
    }
  }
}

.technology {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fafbfe;
  padding: 0 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > .technology-text {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > .technology-list {
    display: flex;
    justify-content: space-between;
    column-gap: 0.24rem;
    padding-bottom: 2.34rem;

    > .technology-item {
      background: #F5F5F7;
      border-radius: 0.48rem;

      > .technology-img {
        width: 5.64rem;
        margin-bottom: 0.24rem;
      }

      > .technology-sub-text {
        font-weight: 400;
        font-size: 0.28rem;
        color: #000000;
        text-align: center;
        line-height: 0.32rem;
      }

      > .technology-text {
        font-weight: 500;
        font-size: 0.4rem;
        color: #000000;
        text-align: center;
        line-height: 0.68rem;
        margin-bottom: 0.24rem;
      }
    }
  }

  > .technology-copyright {
    position: absolute;
    bottom: 1.4rem;
    left: 0.9rem;

    font-weight: 400;
    font-size: 0.12rem;
    color: #999999;
    text-align: left;
    line-height: 0.17rem;
  }
}
</style>
